import React from 'react';
import { FileText, Zap, Users, ShieldCheck, Lock, CreditCard, Globe } from 'lucide-react';
import { Button } from './Shared';
export const Hero = () => {
  return <section className="relative px-4 overflow-hidden py-10 md:py-16 pt-[32px] pb-[32px]" data-id="element-152">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_50%_-20%,rgba(212,175,55,0.15),transparent_70%)] pointer-events-none" data-id="element-153"></div>
      <div className="absolute top-20 left-10 w-2 h-2 bg-premium-gold-luminous rounded-full opacity-40 blur-[1px]" data-id="element-154"></div>
      <div className="absolute top-40 right-20 w-3 h-3 bg-premium-gold-luminous rounded-full opacity-20 blur-[2px]" data-id="element-155"></div>

      <div className="max-w-6xl mx-auto text-center relative z-10" data-id="element-156">
        <div className="inline-flex items-center space-x-2 text-premium-gold-luminous font-sans font-bold tracking-[0.15em] uppercase text-[9px] md:text-xs mb-4 bg-white/5 px-3 py-1 rounded-full border border-white/10 backdrop-blur-sm" data-id="element-157">
          <Globe className="w-3 h-3" data-id="element-158" />
          <span data-id="element-159">MUNDO PRÁCTICO™</span>
        </div>

        <h1 className="md:text-5xl lg:text-6xl text-white mb-2 tracking-tight max-w-3xl mx-auto px-2 font-[800] font-[Montserrat,_sans-serif] text-[28px]" data-id="element-160">
          Todo lo que necesitás para manejar <br className="hidden md:block" data-id="element-161" />
          <span className="text-premium-gold-luminous" data-id="element-162">
            los berrinches de tu hijo.
          </span>
        </h1>
        <p className="text-base md:text-xl font-sans font-medium mb-6 opacity-90 text-[#FFFFFF]" data-id="element-163">
          Listo. Desde hoy.
        </p>

        <div className="relative max-w-2xl mx-auto px-4 mb-6" data-id="element-164">
          <div className="absolute inset-0 bg-[radial-gradient(circle,rgba(212,175,55,0.15)_0%,transparent_60%)] rounded-full blur-2xl" data-id="element-165"></div>
          <img src="https://cdn.magicpatterns.com/uploads/d2Eudanot4EDAUZoAu2ztw/MockUp-Noches-de-Paz-_2__(2)_(1).webp?w=500" alt="MegaPack Calma Total" className="relative z-10 w-full max-w-[280px] md:max-w-[500px] mx-auto h-auto drop-shadow-[0_15px_30px_rgba(0,0,0,0.4)]" width={500} height={500} loading="eager" fetchPriority="high" data-id="element-166" />
        </div>

        <div className="max-w-xl mx-auto space-y-2 mb-6 px-2" data-id="element-167">
          <p className="text-white font-bold text-xs md:text-base tracking-wide uppercase" data-id="element-168">
            El sistema N°1 de crianza práctica en Argentina
          </p>
          <p className="text-gray-200 text-xs md:text-sm leading-snug font-sans max-w-md mx-auto" data-id="element-169">
            Protocolos + herramientas + frases exactas listos para usar. Sin
            improvisar. Sin explotar. Sin culpa.
          </p>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-2 md:gap-6 text-white/90 mb-8 max-w-md md:max-w-none mx-auto" data-id="element-170">
          {[{
          icon: FileText,
          text: '100% PDF'
        }, {
          icon: Zap,
          text: 'Acceso en 5 min'
        }, {
          icon: Users,
          text: 'Niños 1 a 7 años'
        }, {
          icon: ShieldCheck,
          text: 'Garantía 7 días'
        }].map((item, i) => <div key={i} className="flex items-center space-x-1.5 bg-white/5 px-2.5 py-1 rounded-md border border-white/10 backdrop-blur-sm" data-id="element-171">
              <item.icon className="w-3 h-3 md:w-4 md:h-4 text-premium-gold-luminous" data-id="element-172" />
              <span className="text-[10px] md:text-sm font-semibold tracking-wide whitespace-nowrap" data-id="element-173">
                {item.text}
              </span>
            </div>)}
        </div>

        <Button href="#plan-premium" className="w-full md:w-auto text-sm md:text-xl px-6 md:px-12 py-4 md:py-6 shadow-[0_0_30px_rgba(212,175,55,0.25)]" data-id="element-174">
          🟠 → QUIERO MI MEGAPACK AHORA
        </Button>

        <div className="flex items-center justify-center space-x-4 text-[10px] md:text-sm text-gray-400 mt-6 font-medium" data-id="element-175">
          <span className="flex items-center" data-id="element-176">
            <Lock className="w-4 h-4 mr-2 text-green-400" data-id="element-177" /> Pago seguro
          </span>
          <span className="w-px h-4 bg-white/10" data-id="element-178"></span>
          <span className="flex items-center" data-id="element-179">
            <CreditCard className="w-4 h-4 mr-2 text-blue-400" data-id="element-180" /> Mercado Pago
          </span>
        </div>
      </div>
    </section>;
};